import { IAppRoute, IAppRouteBase } from "../entities/app-route";
import { ObjectMap } from "../framework/entities/object-map";
import { forEach } from "../framework/utils/collection";
import { xlate, xlationContext } from "../framework/utils/i18n";
import { CreatePresentationPage } from "./presentation/pages/create-presentation";
import { MyPresentationsPage } from "./presentation/pages/my-presentations";
import { PresentationPage } from "./presentation/pages/perform-presentation";
import { UpdatePresentationPage } from "./presentation/pages/update-presentation";

xlationContext('App route definitions');

const buildRegex = (template: string) => {
    let normalizedTemplate = template.trim();
    normalizedTemplate = normalizedTemplate[0] === '/' ? normalizedTemplate.substring(1) : normalizedTemplate;

    const pathParts = normalizedTemplate.split('/');
    const actualParts = pathParts.map(p => {
        if(p === ':guid') {
            return '[0-9a-f]{32}';
        }
        if(p === ':int') {
            return '[0-9]+';
        }
        return p;
    });

    const rx = `^\\/${actualParts.join('\\/')}$`;
    return new RegExp(rx, 'i');
};

class AppRouteConfig {
    public home: IAppRoute = {
        key: 'home',
        urlTemplate: '/',
        url: () => '/',
        icon: 'FileComment',
        exact: true,
        regex: null,
        sideMenuSupported: true,
        topLevel: true,
        allowInvalidSubscription: true,
        component: MyPresentationsPage,
    };

    public myPresentations: IAppRoute = {
        key: 'myPresentations',
        urlTemplate: `/${xlate('presentations')}`,
        url: () => `/${xlate('presentations')}`,
        icon: 'FileComment',
        exact: true,
        regex: null,
        sideMenuSupported: true,
        topLevel: true,
        allowInvalidSubscription: true,
        component: MyPresentationsPage,
    };

    public createPresentation: IAppRoute = {
        key: 'createPresentation',
        urlTemplate: `/${xlate('presentations')}/${xlate('new')}`,
        url: () => `/${xlate('presentations')}/${xlate('new')}`,
        icon: 'FileComment',
        exact: true,
        regex: null,
        sideMenuSupported: true,
        topLevel: true,
        allowInvalidSubscription: false,
        component: CreatePresentationPage,
    };

    public updatePresentation: IAppRoute<(id: string) => string> = {
        key: 'updatePresentation',
        urlTemplate: `/${xlate('presentations')}/:id/${xlate('edit')}`,
        url: (id: string) => `/${xlate('presentations')}/${id}/${xlate('edit')}`,
        icon: 'FileComment',
        exact: true,
        regex: buildRegex(`/${xlate('presentations')}/:guid/${xlate('edit')}`),
        sideMenuSupported: true,
        topLevel: true,
        allowInvalidSubscription: false,
        component: UpdatePresentationPage,
    };

    public performPresentation: IAppRoute<(id: string) => string> = {
        key: 'performPresentation',
        urlTemplate: `/${xlate('presentations')}/:id`,
        url: (id: string) => `/${xlate('presentations')}/${id}`,
        icon: 'FileComment',
        exact: true,
        regex: buildRegex(`/${xlate('presentations')}/:guid`),
        sideMenuSupported: true,
        topLevel: true,
        allowInvalidSubscription: false,
        component: PresentationPage,
    };
}

export const AppRoutes = new AppRouteConfig();

export function getAppRouteByKey(key: string): IAppRouteBase | undefined {
    const appRoutes = AppRoutes as unknown as ObjectMap<IAppRouteBase>;
    let selectedRoute: IAppRouteBase | undefined = undefined;

    forEach(appRoutes, route => {
        if(route.key === key) {
            selectedRoute = route;
            return false; // break
        }
    });

    return selectedRoute;
}

export const getAppRouteByPathname = (pathname: string): IAppRouteBase | undefined => {
    const appRoutes = AppRoutes as unknown as ObjectMap<IAppRouteBase>;
    let matchingRoute: IAppRouteBase | undefined = undefined;

    forEach(appRoutes, route => {
        if((!!route.regex && route.regex.test(pathname)) ||
        (!route.regex && route.urlTemplate === pathname.toLowerCase())) {
            matchingRoute = route;
            return false; // break;
        }
    });

    return matchingRoute;
}

export const getAppRoutesArray = (): IAppRouteBase[] => {
    const appRoutes = AppRoutes as unknown as ObjectMap<IAppRouteBase>;
    const routes: IAppRouteBase[] = [];

    forEach(appRoutes, route => {
        routes.push(route);
    });

    return routes;
};